import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY}.${BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.GENERAL_INFO}` as const;

export const ABOUT_COMPANY_GENERAL_NAMES = {
  LEGAL_STRUCTURE: 'legalStructure',

  WEBSITE_URL: 'websiteUrl',
  PHONE: 'phone',
  EMAIL: 'email',
  PHONE_FORMAT: 'phoneFormat',

  FACEBOOK: 'facebook',
  LINKEDIN: 'linkedin',
  INSTAGRAM: 'instagram',
  OTHER: 'other',

  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  POSITION: 'position',
  CONTACT_PERSON_EMAIL: 'contactPersonsEmail',
  CONTACT_PERSON_PHONE: 'contactPersonPhone',
  CONTACT_PERSON_PHONE_FORMAT: 'contactPersonPhoneFormat',
  LIST_OF_FOUNDERS: 'listOfFounders',
} as const;

export const LIST_OF_FOUNDERS_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  SHARE_IN_COMPANY: 'share',
} as const;

export interface IGeneralAboutCompanyListOfFoundersForm {
  [LIST_OF_FOUNDERS_FIELDS.FIRST_NAME]: string;
  [LIST_OF_FOUNDERS_FIELDS.LAST_NAME]: string;
  [LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY]: string;
}

export interface IGeneralAboutCompanyForm {
  [ABOUT_COMPANY_GENERAL_NAMES.LEGAL_STRUCTURE]: string;

  [ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.PHONE]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.PHONE_FORMAT]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.EMAIL]?: string;

  [ABOUT_COMPANY_GENERAL_NAMES.FACEBOOK]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.LINKEDIN]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.INSTAGRAM]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.OTHER]?: string;

  [ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME]: string;
  [ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME]: string;
  [ABOUT_COMPANY_GENERAL_NAMES.POSITION]: string;
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_EMAIL]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE]?: string;
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE_FORMAT]?: string;

  [ABOUT_COMPANY_GENERAL_NAMES.LIST_OF_FOUNDERS]: IGeneralAboutCompanyListOfFoundersForm[];
}

export const listOfFoundersInitialValues: IGeneralAboutCompanyListOfFoundersForm = {
  [LIST_OF_FOUNDERS_FIELDS.FIRST_NAME]: '',
  [LIST_OF_FOUNDERS_FIELDS.LAST_NAME]: '',
  [LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY]: '',
};

export const generalAboutCompanyInitialValues: IGeneralAboutCompanyForm = {
  [ABOUT_COMPANY_GENERAL_NAMES.LEGAL_STRUCTURE]: '',

  [ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.PHONE]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.EMAIL]: '',

  [ABOUT_COMPANY_GENERAL_NAMES.FACEBOOK]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.LINKEDIN]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.INSTAGRAM]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.OTHER]: '',

  [ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.POSITION]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_EMAIL]: '',
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE]: '',

  [ABOUT_COMPANY_GENERAL_NAMES.LIST_OF_FOUNDERS]: [listOfFoundersInitialValues],
};
